import { Component, input } from '@angular/core'
import { RouterLink } from '@angular/router'

import { ButtonComponent } from '@ui/components/button/button.component'
import { IconComponent } from '@ui/components/icon/icon.component'
import { StampComponent } from '@ui/components/stamp/stamp.component'
import { Confirmable } from '@ui/models/confirmable'

@Component({
  selector: 'sb-negative-balance',
  imports: [IconComponent, StampComponent, ButtonComponent, RouterLink],
  templateUrl: './negative-balance.component.html',
})
export class NegativeBalanceComponent extends Confirmable {
  readonly balance = input.required<number>()
}
